<template>


  <v-fab-transition>
    <v-card
        class=""
        width="540"
        v-show="active"
        height="675"
        transparent
        flat
        elevation="20"

        style="margin-top:40px;margin-left:40px;border-radius: 20px;"
    >
      <v-system-bar
          style="position: absolute;z-index: 2;width:100%;height:40px;background: rgba(0,0,0,0.0)"

          dark
      >
        <h4 class="shadowed" style="width:100%;text-align: center;font-family: objektiv-mk1, sans-serif; font-weight: bold;">Sponsrat meddelande från ROCKER</h4>
      </v-system-bar>

      <video
          muted
          v-show="stage===0"
          autoplay
          id="video_intro"
          height="675"
          width="540"
          style="border-radius: 20px;position: absolute;outline:none; top: 0; left: 0; width: 100%; height: 100%; clip-path: inset(0px 0px);"
        src="/api/images/rocker2_in.webm"
      >
      </video>
      <video
          muted
          loop
          v-show="stage===1"
          id="video_hold"

          autoplay
          height="675"
          width="540"
          style="border-radius: 20px;position: absolute;outline:none; top: 0; left: 0; width: 100%; height: 100%; clip-path: inset(0px 0px);"
          src="/api/images/rocker2_hold.webm"
      >

      </video>
      <v-row           v-show="card_stage===3"
                       style="position: absolute;bottom:120px;width:100%;background: transparent;">
        <v-col class="py-0">
          <v-list style="background: transparent;" dense subheader>

            <v-list-item

            >

              <v-chip   class="ma-2" style="opacity:0.3;" text-color="#2C2847" color="#FFD5AF" v-if="votes0.length>2" > <b>{{votes0[votes0.length-3]}}</b> </v-chip>

            </v-list-item>
            <v-list-item

            >

              <v-chip   class="ma-2" style="opacity:0.6;" text-color="#2C2847" color="#FFD5AF" v-if="votes0.length>1" > <b>{{votes0[votes0.length-2]}}</b> </v-chip>

            </v-list-item>
            <v-list-item

            >
              <v-chip style="font-size:20px;"  :class="showlatestVote0 ? 'shake_me':''" class="ma-2" text-color="#2C2847" color="#FFD5AF"   v-if="votes0.length>0"> <b>{{votes0[votes0.length-1]}}</b> </v-chip>

            </v-list-item>
          </v-list>
        </v-col>
        <v-col class="py-0">

        </v-col>
        <v-col style="text-align: right;" class="py-0">
          <v-list style="background: transparent;" dense subheader>

            <v-list-item
                style="text-align: right;"

            >
              <v-spacer></v-spacer>
              <v-chip class="ma-2" style="opacity:0.3;" text-color="#2C2847" color="#C4CDF5"  v-if="votes1.length>2" > <b>{{votes1[votes1.length-3]}}</b> </v-chip>

            </v-list-item>
            <v-list-item

            >
              <v-spacer></v-spacer>
              <v-chip class="ma-2" style="opacity:0.6;" text-color="#2C2847"  color="#C4CDF5" v-if="votes1.length>1" > <b>{{votes1[votes1.length-2]}}</b> </v-chip>

            </v-list-item>
            <v-list-item

            >
              <v-spacer></v-spacer>
              <v-chip  style="font-size:20px;" :class="showlatestVote1 ? 'shake_me':''"  class="ma-2" text-color="#2C2847" color="#C4CDF5"   v-if="votes1.length>0"> <b>{{votes1[votes1.length-1]}}</b> </v-chip>

            </v-list-item>
          </v-list>

        </v-col>
      </v-row>
      <v-slide-y-transition>
        <v-card flat color="transparent" style="height:200px;width:100%;bottom:0;position: absolute;" v-show="card_stage===1">
          <v-card-text>
            <h4 style="width:100%;text-align: center;font-family: objektiv-mk1, sans-serif; font-weight: bold;font-size:30px;line-height:40px;color:#494283;">Skaffa Rockerkortet.<br>Få 500 kr. * <br><small style="text-align: center;width:100%;font-size:14px;">*Klicka på länken i chatten för instruktioner och villkor!</small></h4>          </v-card-text>
        </v-card>
      </v-slide-y-transition>

      <v-slide-y-transition>
      <v-card flat color="transparent" style="height:200px;width:100%;bottom:0;position: absolute;" v-show="card_stage===2">
        <v-card-text>
          <h4 style="width:100%;text-align: center;font-family: objektiv-mk1, sans-serif; font-weight: bold;font-size:30px;line-height:40px;color:#494283;">Vad skulle chatten göra för<br> <span style="font-size:36px;">500 kr?</span></h4>
        </v-card-text>
      </v-card>
      </v-slide-y-transition>
      <v-slide-y-transition>
        <v-card flat color="transparent" style="height:200px;width:100%;top:150px;position: absolute;" v-show="card_stage===3">
          <v-card-text>

            <h4 style="width:100%;text-align: center;font-family: objektiv-mk1, sans-serif; font-size:20px;line-height:40px;color:#F2F4FF;">För 500 kronor:</h4>
          </v-card-text>
          <v-card-text>
            <h4 style="width:100%;text-align: center;font-family: objektiv-mk1, sans-serif; font-weight: bold;font-size:30px;line-height:40px;color:#F2F4FF;">
              {{ question }}?</h4>
          </v-card-text>
        </v-card>
      </v-slide-y-transition>
      <v-slide-y-transition>
        <v-card flat color="transparent" style="height:200px;width:100%;top:150px;position: absolute;" v-show="card_stage===4">
          <v-card-text>
            <h4 style="margin-left:10%;width:80%;text-align: center;font-family: objektiv-mk1, sans-serif; font-size:20px;line-height:40px;color:#F2F4FF;">{{votes_result}} <br>..men det finns lättare sätt att tjäna <br><span style="font-size:30px;">500 kronor</span></h4>
          </v-card-text>
          <v-card-text>
          </v-card-text>
            <v-btn dark style="left:85px;font-family: objektiv-mk1, sans-serif; font-weight: bold;font-size:20px;border-radius: 10px;" x-large color="#6235FF">Kolla länken i chatten!</v-btn>
        </v-card>
      </v-slide-y-transition>
      <v-fab-transition>
      <v-progress-linear
          background-color="#C4CDF5"
          color="#FFD5AF"
          :value="ratio"
          style="bottom:0;position:absolute;border-radius: 0 0 18px 18px;"
          v-show="show_progress_bar"
          height="100"
          :stream="true"
      >
        <template >
          <h2 style="font-family: objektiv-mk1, sans-serif; font-weight: bold;font-size:30px;line-height:40px;color:#2C2847;margin-left:15px;">!ja</h2>
          <v-spacer></v-spacer>
          <h4 style="width:100%;text-align: center;font-family: objektiv-mk1, sans-serif; font-weight: bold;font-size:30px;line-height:40px;color:#2C2847;">{{ratio.toFixed(0)}}%</h4>

          <v-spacer></v-spacer>


          <h2 style="font-family: objektiv-mk1, sans-serif; font-weight: bold;font-size:30px;line-height:40px;color:#2C2847;margin-right:15px;">!nej</h2>


        </template>

      </v-progress-linear>
      </v-fab-transition>









    </v-card>
  </v-fab-transition>


</template>

<script>
export default {
  name: "SponsRocker",
  data() {
    return {
      show_progress_bar:false,
      active:false,
      stage:0,
      card_stage:0,
      compMode:true,
      latestVote0:"",
      showlatestVote0:false,
      showlatestVote0Timer:null,
      latestVote1:"",
      showlatestVote1:false,
      showlatestVote1Timer:null,
      questions:[
        "Äta en mask",
        "Sätta en spindel på huvudet",
        "Vara instängd i ett mörkt rum i 3 timmar",
        "Fisa så din crush hör",
        "Hoppa bungyjump",
        "Hoppa fallskärm",
        "Bada isvak i 5 minuter",
        "Göra 300 Squats",
        "Gilla alla Instagram posts som din crush lagt upp",
        "Blunda i en timme",
        "Äta en rå lök",
        "Äta en matsked senap",
        "Vaxa benen",
        "Berätta det mest pinsamma du gjort",
        "Posta din äldsta selfie på instagram",
        "Bli kittlad i 5 minuter",
        "Äta en matsked wasabi",
        "Tatuera “Mamma” på ryggen",
        "Äta något som legat i soporna",
        "Slicka på en frusen lyktstolpe",
        "Städa varje dag i en vecka",
        "Gå på en offentlig toalett utan att låsa",
        "Skriva “Jag luktar svett” till din crush",
        "Göra en freestyle rap och lägga upp på instagram",
        "Äta upp ett bananskal",
        "Klippa grannens gräsmatta med sax"
      ],
      question:"",
      votes0:[

      ],
      votes1:[

      ]


    }
  },
  mounted:function(){
    let u=this.$route.query.u;
    this.$socket.emit('spons_listen_rocker',u);









  },

  computed: {
    ratio:function(){
      if(this.votes0.length===0 && this.votes1.length===0){
        return 50
      }
      else if(this.votes0.length===0 && this.votes1.length!==0){
        return 0
      }
      else if(this.votes0.length!==0 && this.votes1.length===0){
        return 100
      }
      else{
        return (this.votes0.length/(this.votes0.length+this.votes1.length)*100)
      }
    },
    votes_result:function(){
      let name="";
      let return_me="";
      if(this.votes0.length>1){
        name=this.votes0[Math.floor(Math.random()*this.votes0.length)];
        return_me=`${name} och ${this.votes0.length-1} andra ${this.question.toLowerCase().replace(" din "," sin ").replace(" du "," de ")}`;
      }
      else if(this.votes1.length>1){
        name=this.votes1[Math.floor(Math.random()*this.votes1.length)];
        return_me=`Inte ens ${name} skulle ${this.question.toLowerCase().replace(" din "," sin ").replace(" du "," de ")}`;

      }else{
        return_me=`Att ${this.question.toLowerCase()} är ingen höjdare`;

      }
      return return_me
    }

  },

  sockets: {


    show_rocker:function(){
      this.active=true;
      let self=this;

      this.question=this.questions[Math.floor(Math.random()*this.questions.length)];
      //this.question=this.questions[13];

      this.active=true;
      setTimeout(function(){
        self.card_stage=1;

      },2000);
      setTimeout(function(){
        self.card_stage=2;

      },7500);
      setTimeout(function(){
        self.card_stage=-1;

      },13000);
      setTimeout(function(){
        self.card_stage=3;

      },14500);
      setTimeout(function(){
        self.show_progress_bar=true;

      },15500);
      setTimeout(function(){
        self.stage=1;

      },16000);
      setTimeout(function(){
        self.card_stage=4;

      },39000);
      setTimeout(function(){
        self.$socket.emit('bye_spons_rocker',[self.votes0.length+self.votes1.length]);
        self.reset_all();


      },45000);


    },
    vote:function([message,user]){
      if(message==="ja" && !(this.votes0.includes(user) && !(this.votes1.includes(user)))){
        this.vote0(user)
      }else if(message==="nej" && !(this.votes0.includes(user)) && !(this.votes1.includes(user))){
        this.vote1(user)
      }



    },
    connected:function(){
    }
  },
  methods:{

    reset_all:function(){


      this.active=false;
      this.show_progress_bar=false
      this.stage=0
      this.card_stage=0
      this.compMode=true
      this.latestVote0=""
      this.showlatestVote0=false
      this.showlatestVote0Timer=null
      this.latestVote1=""
      this.showlatestVote1=false
      this.showlatestVote1Timer=null
      this.votes0=[]
      this.votes1=[]
      let video_intro = document.getElementById('video_intro');
      video_intro.pause();
      video_intro.currentTime = 0;
      video_intro.load();

      let video_hold = document.getElementById('video_hold');
      video_hold.pause();
      video_hold.currentTime = 0;
      video_hold.load();
    },

    vote0:function(voter){
      clearTimeout(this.showlatestVote0Timer);
      this.latestVote0=voter;
      this.showlatestVote0=true;
      let self=this;
      this.votes0.push(voter);
      this.$emit("vote",["1",voter]);
      this.showlatestVote0Timer=setTimeout(function(){
        self.showlatestVote0=false;
      },1000)
    },
    vote1:function(voter){
      clearTimeout(this.showlatestVote0Timer);
      this.latestVote1=voter;
      this.showlatestVote1=true;
      let self=this;
      this.votes1.push(voter);
      this.$emit("vote",["2",voter]);

      this.showlatestVote1Timer=setTimeout(function(){
        self.showlatestVote1=false;
      },1000)
    },
    generate_fake_votes:function(){
      let fake_names=[
        "2cuteilla",
        "Actuallynner",
        "Americast",
        "AmyKrool",
        "Artuggle",
        "Asedayal",
        "Barqualin",
        "Bazartip",
        "Blondeange",
        "Boardfi",
        "Boardintech",
        "Calcite",
        "Candyes",
        "Cattapp",
        "ChickEssence",
        "Comfylk",
        "Confire",
        "Coniervo",
        "Contreelo",
        "Cottonor",
        "Cyberlo",
        "Desightit",
        "Dictatorma",
        "DiddyParis",
        "Disseri",
        "Exterolo",
        "Fabrium",
        "Fareo",
        "FelineFaith",
        "Flexisys",
        "FluentGrabs",
        "Fraserstru",
        "FullyWet",
        "GazetteExclusive",
        "Givelz",
        "GrimSun",
        "GrimWitch",
        "Gurlyco",
        "HeadDev",
        "HeheMoto",
        "HeheRob",
        "Hipbb",
        "Huningst",
        "InfernoKix",
        "Integar",
        "Islandella",
        "JimMj",
        "JoFinest",
        "KenkaMega",
        "Laoandr",
        "LeonHead",
        "Listin",
        "Losimuni",
        "Lummobe",
        "Mcanardua",
        "Mcel",
        "Midnighter",
        "MinyTinnys",
        "Mohawkey",
        "NessNaybor",
        "NoticeSaiyan",
        "NycBleak",
        "Papass",
        "Pellinkie",
        "PerfectHippo",
        "Persdant",
        "Phiard",
        "PiraAsta",
        "Racer2cool",
        "RadioThesoy",
        "Relysi",
        "RocketSister",
        "Ryothus",
        "Sablinkak",
        "Sageolag",
        "Sanlc",
        "Scirraybo",
        "SelfCuddly",
        "Senaouder",
        "SereneKeepup",
        "SkierSnoop",
        "Sonflina",
        "Spiceelli",
        "Spicernin",
        "Sublega",
        "TalentCharms",
        "TalesStylish",
        "TaruRocker",
        "Theevilla",
        "TigerMusic",
        "ToyFlavored",
        "TrendyShoes",
        "TrustQuayle",
        "Ttiendos",
        "Twiter",
        "Tyob",
        "V2co",
        "Vamim",
        "Venabba",
        "Verterma"
      ];
      let name=fake_names[Math.floor(Math.random()*fake_names.length)]
      var vote0 = Math.random() >= 0.5;
      if(vote0){
        this.vote0(name);
      }
      else{
        this.vote1(name);
      }
      let self=this;

      setTimeout(function(){
        if(self.card_stage===3){
          self.generate_fake_votes();
        }
      },750+(Math.random()*500))
    },

  }
}
</script>

<style>

.shadowed{
  color: rgb(163,163,163);
}
iframe{
  width:100% !important;
  height:100% !important;
}

@keyframes MOVE-BG {

  from {
    -webkit-transform: translateX(-200px);
    -moz-transform: translateX(-200px);
    -ms-transform: translateX(-200px);
    -o-transform: translateX(-200px);
    transform: translateX(-200px);

  }
  to {

    -webkit-transform: translateX(-350px);
    -moz-transform: translateX(-350px);
    -ms-transform: translateX(-350px);
    -o-transform: translateX(-350px);
    transform: translateX(-350px);

  }
}
.move_bg{
  animation-name: MOVE-BG;
  animation-duration: 30s;
  animation-timing-function: ease-in-out;
  animation-iteration-count: 1;
  -webkit-animation-fill-mode: forwards;
}

.hidden {
  visibility: hidden;
  opacity: 0;
  transition: visibility 0s 2s, opacity 2s linear;
}
.visible {
  visibility: visible;
  opacity: 1;
}

.shake_me{
  animation: shake 0.3s;
}

@keyframes shake {
  0% { transform: translate(1px, 1px) rotate(0deg); }
  10% { transform: translate(-1px, -2px) rotate(-1deg); }
  20% { transform: translate(-3px, 0px) rotate(1deg); }
  30% { transform: translate(3px, 2px) rotate(0deg); }
  40% { transform: translate(1px, -1px) rotate(1deg); }
  50% { transform: translate(-1px, 2px) rotate(-1deg); }
  60% { transform: translate(-3px, 1px) rotate(0deg); }
  70% { transform: translate(3px, 1px) rotate(-1deg); }
  80% { transform: translate(-1px, -1px) rotate(1deg); }
  90% { transform: translate(1px, 2px) rotate(0deg); }
  100% { transform: translate(1px, -2px) rotate(-1deg); }
}

</style>
